import {useEffect, useState} from 'react'
import {FontAwesomeIcon} from '@fortawesome/react-fontawesome'

type CheckListItemProps = {
    item: ItemInterface;
    value: string;
}

interface ItemInterface {
    regex: string;
    label: string;
}

export const CheckListItem = ({item, value}: CheckListItemProps) => {
    const [icon, setIcon] = useState('xmark');
    const [iconColor, setIconColor] = useState('text-danger')

    useEffect(() => {
        const isValid = item.regex.test(value);
        setIcon(isValid ? 'check' : 'xmark')
        setIconColor(isValid ? 'text-success' : 'text-danger')
    }, [value]);

    return (
        <li className={'d-flex align-items-center'}>
            <FontAwesomeIcon icon={icon} className={`mr-2 ${iconColor}`} style={{width: '15px'}} />
            {item.label}
        </li>
    )
}
